import { render, staticRenderFns } from "./BackCover.vue?vue&type=template&id=1417ea8c&"
import script from "./BackCover.vue?vue&type=script&lang=js&"
export * from "./BackCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports